export default __webpack_public_path__ + "static/media/lesnik_winter_a_11.284a078b.svg";